import React from 'react';
import PropTypes from 'prop-types';

import {
  ExtendedBox,
} from '../../../coreui';

import Tabs from '../../../components/tabs';
import PropertyTypesChart from './propertyTypesChart';

const Nav = ({
  stats,
  tabs,
  strings,
}) => {
  return (
    <Tabs>
      <ExtendedBox
        label={tabs[0]}
        w="100%"
      >
        <PropertyTypesChart
          data={stats.first}
          strings={strings[0]}
          label={tabs[0]}
        />
      </ExtendedBox>
      <ExtendedBox
        label={tabs[1]}
        w="100%"
      >
        <PropertyTypesChart
          data={stats.second}
          strings={strings[1]}
          label={tabs[1]}
        />
      </ExtendedBox>
      <ExtendedBox
        label={tabs[2]}
        w="100%"
      >
        <PropertyTypesChart
          data={stats.third}
          strings={strings[2]}
          label={tabs[2]}
        />
      </ExtendedBox>
    </Tabs>
  );
};

Nav.propTypes = {
  stats: PropTypes.object,
  tabs: PropTypes.array,
  strings: PropTypes.array,
};

export default Nav;
